import React, { useState } from "react";
import Modal from "@components/modal";
import {
  AddonName,
  AddonContainer,
  DetailsWrapper,
  Description,
  Price,
  AddonCardWrapper,
  ModalHeading,
  Tag,
  Wrapper
} from "./styles";
import Radio from "components/common/radio";

import DOMPurify from "isomorphic-dompurify";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { getInrFormat } from "@utils/inrFormatter";
import Badge from "@components/common/badge";
import { getAddonDescription } from "@utils/index";
import { useGetInitialSelectedVariant } from "../customHooks";
import { setAnalytics } from "@actions/setAnalyticsData";

interface IPaCoverVariantsModal {
  showModal: boolean;
  primaryCtaClickHandler: Function;
  secondaryCtaClickHandler: Function;
  isCoverSelected: boolean;
  variants: any;
  isUpgradeModal?: boolean;
  modalContent?: any;
  handleClose: Function;
  id: string | undefined;
  selectedVariantId: string | null;
  defaultVariantIdSelection: string;
  addonId: string;
  lockBackgroundInteraction?: boolean;
}

const AddonVariantsModal: React.FC<IPaCoverVariantsModal> = ({
  showModal,
  isUpgradeModal,
  variants,
  isCoverSelected,
  primaryCtaClickHandler,
  secondaryCtaClickHandler,
  handleClose,
  selectedVariantId,
  defaultVariantIdSelection,
  addonId,
  modalContent,
  lockBackgroundInteraction = true
}) => {
  const [selectedVariant, setSelectedVariant] = useState<any>({});

  console.log({ modalContent });

  const { badge, removeCtaText, primaryCtaText, heading } = modalContent;

  useGetInitialSelectedVariant({
    variants,
    selectedVariantId,
    setSelectedVariant,
    defaultVariantIdSelection,
    addonId,
    isCoverSelected,
    showModal
  });

  const getPrimaryCtaText = () => {
    let text = primaryCtaText;
    if (isCoverSelected) {
      if (selectedVariant?.variant_id !== selectedVariantId) {
        text = "Update cover";
      } else {
        text = "Keep this cover";
      }
    }
    if (isUpgradeModal) {
      text = "Upgrade cover";
    }
    return text;
  };

  return (
    <Modal
      showModal={showModal}
      lockBackgroundInteraction={lockBackgroundInteraction}
      onClose={() => {
        handleClose();
      }}
      showModalFooter
      showPrimaryCta
      primaryCtaText={getPrimaryCtaText()}
      footerWrapperDStyles={{
        width: "100%",
        padding: "0px"
      }}
      primaryCtaClickHandler={() => {
        primaryCtaClickHandler(selectedVariant);
        handleClose();
      }}
      showSecondaryCta={isCoverSelected && !isUpgradeModal}
      secondaryCtaText={removeCtaText}
      secondaryCtaType="LINK"
      secondaryCtaClickHandler={() => {
        secondaryCtaClickHandler(selectedVariant);
        handleClose();
      }}
      secondaryCtaLinkType="DANGER"
      modalHeading={
        <ModalHeading
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(heading)
          }}
        />
      }
    >
      <Wrapper>
        {variants?.map((variant) => {
          const selected = variant?.variant_id === selectedVariant?.variant_id;
          const isPlusVariant = variant?.variant_id === "plus";

          if (isUpgradeModal && variant?.variant_id === "default") {
            return <></>;
          } else {
            return (
              <AddonCardWrapper
                onClick={() => {
                  setSelectedVariant(variant);
                  setAnalytics({
                    variant_name: variant?.variant_id
                  });
                }}
                selected={selected}
              >
                <DetailsWrapper>
                  <AddonContainer>
                    <div>
                      {isPlusVariant && (
                        <Badge
                          is_visible
                          text={badge?.text}
                          type={badge?.type}
                          styles={{ marginBottom: "12px" }}
                        />
                      )}
                      <Flex
                        style={{
                          flexDirection: "row",
                          gap: "0.5rem",
                          alignItems: "center"
                        }}
                      >
                        <AddonName
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(variant?.display_name)
                          }}
                        />
                        <Tag isPlusVariant={isPlusVariant}>
                          {isPlusVariant ? "PLUS" : "LITE"}
                        </Tag>
                      </Flex>
                    </div>
                    <Radio isSelected={selected} size={16} />
                  </AddonContainer>

                  <Price>₹{getInrFormat(variant?.price?.net_premium)}</Price>
                  <Description
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        getAddonDescription(variant?.detailed_description)
                      )
                    }}
                  />
                </DetailsWrapper>
              </AddonCardWrapper>
            );
          }
        })}
      </Wrapper>
    </Modal>
  );
};

export default AddonVariantsModal;
